import React, { useCallback, useEffect, useState } from 'react';
import '@smiles/core-engine';
import { useTranslation } from 'react-i18next';
import {
  SearchPanel,
} from './components';
import { Provider } from 'react-redux';
import { store } from './store';
import { initCore, saveAuthToken } from './smiles-core';

const App = () => {
  const { t } = useTranslation();
  const [recentSearches] = useState([]);
  const [isReady, setIsReady] = useState<boolean>(false);

  const appRoutine = useCallback(async () => {
    const sessionToken = await localStorage.getItem('session-token');
    await saveAuthToken(sessionToken);
    await initCore();
    setIsReady(true);
  }, []);

  useEffect(() => {
    appRoutine();
  }, [appRoutine])

  if (isReady) {
    return (
      <Provider store={store}>
        <SearchPanel userSearchData={[{ label: t('smlsAutoCompleteSearch.recentSearchLabel'), items: recentSearches }]} />
      </Provider>
    );
  }
  return null
};

export default App;

export {
  useTranslation,
  SearchPanel,
  Provider,
  store
}